import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Modal, ModalControlModalProps, Text } from '@frontend/design-system';

export const CancelEditModal = ({
  modalProps,
  disabled,
  onQuitClick,
  onSaveAndQuitClick,
}: {
  modalProps: ModalControlModalProps;
  disabled?: boolean;
  onQuitClick: () => void;
  onSaveAndQuitClick: () => void;
}) => {
  const { t } = useTranslation('phone');

  return (
    <Modal minWidth={600} {...modalProps}>
      <Modal.Header onClose={modalProps.onClose}>{t('Unsaved Changes')}</Modal.Header>
      <Modal.Body>
        <div css={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(2), margin: theme.spacing(1, 0, 0) }}>
          <Text>{t('You have unsaved changes.')}</Text>
          <Text>{t('Do you want to save your work before leaving?')}</Text>
        </div>
      </Modal.Body>
      <Modal.Footer
        css={css`
          display: flex;
          justify-content: space-between;
          gap: ${theme.spacing(2)};
        `}
      >
        <Button destructive variant='tertiary' onClick={onQuitClick} size='large'>
          {t('Discard and Exit')}
        </Button>
        <div css={{ display: 'flex', gap: theme.spacing(2) }}>
          <Button variant='secondary' onClick={modalProps.onClose} size='large'>
            {t('Continue Editing')}
          </Button>
          <Button onClick={onSaveAndQuitClick} disabled={disabled} size='large'>
            {t('Save and Exit')}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
